import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import { ValidatorForm } from 'react-material-ui-form-validator'

import {
    GridContainer,
    GridItem4,
    GridItem4xs12,
    GridItem6xs12,
    GridItem8xs12,
    GridItem6,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import { 
    CenarioRadioGroup,
} from '../../../business-rules/RadioGroup/CenarioRadioGroup'

import {
    ButtonIncluirCenarios,
    ButtonAlterarCenarios,
    ButtonExcluirCenarios,
} from './EstudoCompCenarios'

import {
    processaValoresDefaultIniciaisCenarios,
    obterCenario,
    atualizarCenario,
} from './EstudoServiceCenarios'



export const EstudoFormCenarios = ( { values, handleChange, handleSubmit, setFieldValue, toogle, simulacaoFinanceira } ) => {

    processaValoresDefaultIniciaisCenarios(values)

    atualizarCenario(values)

    const CenariosGroup = () => {

        return (
            <CenarioRadioGroup
                className="justify-center"
                name="cenarioAtual"
                value={values.cenarioAtual || ''}
                onChange={(e) => {
                    obterCenario(values, e.target.value)
                    handleChange(e)
                }}
                values={values}
            />
        )
    }

    const GridItemIncAltExcCenarios = values.cenarios.length > 1 ? GridItem6xs12 : GridItem4xs12

    const GridItemIncCenarios = values.cenarios.length > 1 ? GridItem4 : GridItem6

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            {toogle
                ?
                    <CenariosGroup/>
                :
                    <GridContainer
                        className="justify-center"
                    >
                        {(simulacaoFinanceira || values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura) && (
                            <GridItemIncAltExcCenarios>
                                <CardGridEntradaDados>
                                    <CardGridDivBodyEntradaDados>
                                        <GridContainer
                                            className='mb--1'
                                        >
                                            <GridItemIncCenarios>
                                                <ButtonIncluirCenarios
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    simulacaoFinanceira={simulacaoFinanceira}
                                                />
                                            </GridItemIncCenarios>

                                            <GridItem4>
                                                <ButtonAlterarCenarios
                                                    values={values}
                                                    handleChange={handleChange}
                                                    setFieldValue={setFieldValue}
                                                />
                                            </GridItem4>

                                            {values.cenarios.length > 1 && (
                                                <>
                                                    <GridItem4>
                                                        <ButtonExcluirCenarios
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                    </GridItem4>
                                                </>
                                            )}
                                        </GridContainer>
                                    </CardGridDivBodyEntradaDados>
                                </CardGridEntradaDados>
                            </GridItemIncAltExcCenarios>
                        )}

                        {values.cenarios.length > 1 && (
                            <GridItem8xs12>
                                <CardGridEntradaDados>
                                    <CardGridDivBodyEntradaDados>
                                        <CenariosGroup/>
                                    </CardGridDivBodyEntradaDados>
                                </CardGridEntradaDados>
                            </GridItem8xs12>
                        )}

                    </GridContainer>
            }
        </ValidatorForm>
    )
}